import React from 'react';

import { Article } from '../../../../../types/items';
import useStyles from '../styles';
import ActivityBaseComment from '../ActivityBaseComment';

type Props = {
  article: Article;
};


const ActivityProjectStatusComment = ({ article }: Props) => {
  const classes = useStyles();
  const name = article.ref.user?.full_name_first_last;
  const status = article.ref.project_status?.description;

  if (article.ref.is_project_status_change && status !== 'Ready to Edit') {

    return (
      <ActivityBaseComment
        header={(
          <>
            <span className={classes.accent}>{name}</span>
            {' '}
            changed the status to
            {' '}
            <span className={classes.accent}>{status}</span>
            <span className={classes.timestamp}>{article.ref.created_age}</span>
          </>
        )}
      />
    );
  }

  return null;
};

export default ActivityProjectStatusComment;
